// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".noData {\r\n    padding: 3rem;\r\n    text-align: center;\r\n    font-size: 1rem;\r\n}\r\n", "",{"version":3,"sources":["webpack://./src/components/ProgramSummary/index.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kBAAkB;IAClB,eAAe;AACnB","sourcesContent":[".noData {\r\n    padding: 3rem;\r\n    text-align: center;\r\n    font-size: 1rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
